import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import { utilRange } from '../../../../services/utils/utils.service'
import SelectableListComponent from '../../../shared/selectable-list.component'

export default class CastingQuantityPickerComponent extends React.Component<StoreProps, never> {
  render () {
    const { store, data: { offeredService: os, quantity } } = this.props

    return <SelectableListComponent
      name="castingQuantity"
      data={ utilRange(os.quantity_min, os.quantity_max + 0.01, os.quantity_step) }
      value={ quantity }
      formatter={ val => val.toString() }
      onChange={ val => { store.set({ quantity: val }); store.nextFocus({ closeOnMobile: true }) } } />
  }
}
